import { LockSimple, Eye } from "@phosphor-icons/react";
import { usePerms } from "../lib/perms";

export function NoAccess({ what = "this page" }) {
  return (
    <div className="border border-border bg-card px-6 py-16 text-center animate-fade-up" data-testid="no-access-panel">
      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-sm bg-secondary"><LockSimple size={22} className="text-muted-foreground" weight="bold" /></div>
      <h2 className="text-lg font-bold tracking-tight">No access</h2>
      <p className="mt-1 text-sm text-muted-foreground">Your role doesn't have permission to view {what}. Ask an administrator to grant access in Roles &amp; Permissions.</p>
    </div>
  );
}

export function RequireCap({ cap, what, children }) {
  const { loaded, can } = usePerms();
  if (!loaded) return null;
  return can(cap) ? children : <NoAccess what={what} />;
}

export function ViewOnlyBadge({ show }) {
  if (!show) return null;
  return (
    <span className="inline-flex items-center gap-1 rounded-sm border border-amber-500/40 bg-amber-500/10 px-2 py-0.5 text-[11px] font-semibold text-amber-700 dark:text-amber-400" data-testid="view-only-badge">
      <Eye size={12} weight="bold" /> View only
    </span>
  );
}
